import React, { useEffect } from 'react';
import Router from 'next/router';

import { bindActionCreators } from 'redux';
import { useSelector, useStore } from 'react-redux';

import { fetchTracking } from '../../entities/tracking';
import { getBarCode } from '../../entities/tracking/selectors';

import { BarcodeForm } from './tracking-form.component';

export const TrackingForm = () => {
  const { dispatch } = useStore();
  const trackingCode = useSelector(getBarCode);

  const acts = bindActionCreators(
    {
      fetchTracking,
    },
    dispatch
  );

  useEffect(() => {
    const {
      query: { tracking_number: tn, t },
    } = Router;

    const barcode = tn || t;

    if (barcode) {
      acts.fetchTracking({ barcode: barcode.toString() });
    }
  }, []);

  return <BarcodeForm trackingCode={trackingCode} onSubmit={acts.fetchTracking} />;
};
